import moment from 'moment'
import Vue from 'vue';
export default class Helpers {
    static EventBus = new Vue()
    static Codes = {
        Parentesco: {
            JefeHogar: '1'
        }
    }
    static Filters = {
        Empty: "--No especificado",
        EmptyText() {
            return this.Empty;
        },
        Sexo(sex: 'M' | 'F') {
            return sex === 'M' ? 'Masculino' : 'Femenino';
        },
        EstadoCivil(value: 'S' | 'C') {
            return value === 'S' ? 'Soltero' : 'Casado';
        },
        EdadText(value: string) {
            let years = moment().diff(value, 'years', false);
            if (years >= 1) {
                let t = years > 1 ? 'años' : 'año';
                return `${years} ${t}`
            }
            let months = moment().diff(value, 'months', false);
            if (months >= 1) {
                let t = months > 1 ? 'meses' : 'mes';
                return `${months} ${t}`
            }
            let days = moment().diff(value, 'days', false);
            if (days >= 1) {
                let t = days > 1 ? 'dias' : 'dia';
                return `${days} ${t}`
            }
            let hours = moment().diff(value, 'hours', false);
            if (hours >= 1) {
                let t = hours > 1 ? 'horas' : 'hora';
                return `${hours} ${t}`
            }
            return value;
        },
        Edad(value: string) {
            let years = moment().diff(value, 'years', false);
            if (years >= 1)
                return years;
            let months = moment().diff(value, 'months', false);
            if (months >= 1)
                return months;
            let days = moment().diff(value, 'days', false);
            if (days > 1)
                return days;
            let hours = moment().diff(value, 'hours', false);
            if (hours >= 1)
                return hours;
            return 0;
        },
        FromNow(value: string) {
            return moment(value).fromNow();
        },
        Cedula(cedula: string) {
            if (!cedula)
                return process.env.VUE_APP_EMPTY_TEXT || "--No especificado";

            if (cedula.length == 11) {
                let prefijo = cedula.substring(0, 3).concat("-");
                let medio = cedula.substring(3, 10).concat("-");
                let sufijo = cedula.substring(10, 11);
                let result = prefijo.concat(medio).concat(sufijo);
                return result;
            }
            return cedula;
        },
        PhoneToStr(tel: string) {
            if (tel)
                return tel.replace(/\D/g, '');

            return tel;
        },
        Phone(tel: string) {
            if (!tel)
                return process.env.VUE_APP_EMPTY_TEXT || "--No especificado";

            if (tel.length == 10) {
                let prefijo = tel.substring(0, 3);
                let medio = tel.substring(3, 6).concat("-");
                let sufijo = tel.substring(6, 10);
                let result = `(${prefijo}) `.concat(medio).concat(sufijo);
                return result;
            }
            return tel;
        },
        Tarjeta(tarejta: string) {
            if (tarejta && tarejta.length == 16) {
                let prefijo = tarejta.substring(0, 4).concat(" ");
                let medio = tarejta.substring(4, 8).concat(" ");
                let medio2 = tarejta.substring(8, 12).concat(" ");
                let medio3 = tarejta.substring(12, 16).concat(" ");
                let result = prefijo.concat(medio).concat(medio2).concat(medio3);
                return result;
            }
            return tarejta;
        },
        VigenciaSancion(val: number) {
            return val === 1 ? `${val} mes` : `${val} meses`
        },
        NumAMes(value: string) {
            var intMonth = parseInt(value);
            switch (intMonth) {
                case 1:
                    return "Enero";
                case 2:
                    return "Febrebro";
                case 3:
                    return "Marzo";
                case 4:
                    return "Abril";
                case 5:
                    return "Mayo";
                case 6:
                    return "Junio";
                case 7:
                    return "Julio";
                case 8:
                    return "Agosto";
                case 9:
                    return "Septiembre";
                case 10:
                    return "Octubre";
                case 11:
                    return "Noviembre";
                case 12:
                    return "Diciembre";
                default:
                    return "--No especificado"
            }
        },
        Date(value: string) {
            if (value)
                return moment(value).format('L');

            return value;
        },
        Time(value: string) {
            if (value)
                return moment(value).format('LT');

            return value;
        },
        Dots(value: string, length = 10) {
            if (!value) return this.Empty;
            return value.length > length ? value.substring(0, length) + "..." : value;
        }
    }
    static MonthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
    static DayNames = ["D", "L", "M", "MI", "J", "V", "S"]
}
